<div class="wrap">
  <mat-tab-group mat-align-tabs="center" #tabs (selectedTabChange)="changeSelectedCategory($event)" dynamicHeight animationDuration="0ms">
    <mat-tab *ngFor="let vodCategory of vodCategoryList" label="{{ vodCategory.name }}">
      <div class="tab_tit">
        <h3>T-CYCLING</h3>
        <i class="material-icons">&#xe5cc;</i>
        <h3>{{ vodCategory.name }}</h3>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div class="container">
    <div class="row">
      <!--vod view-->
      <ng-template [ngIf]="open == true">
        <div class="col-lg-8" style="padding: 0">
          <div class="view view_vod">
            <div class="view_box">
              <!--loading spinner-->
              <div [hidden]="loading == false" class="wrap_spin">
                <mat-spinner diameter="50" class="custom-spinner" style="margin: 0 auto; position: absolute; bottom: 10%; left: calc(50% - 25px)"></mat-spinner>
              </div>

              <div [hidden]="loading == true">
                <div *ngIf="isString">
                  <div [innerHTML]="playSource"></div>
                </div>
                <div *ngIf="!isString">
                  <media-player
                    id="myVideo"
                    src="{{ playSource }}"
                    load="eager"
                    view-type="video"
                    stream-type="on-demand"
                    crossorigin
                    playsinline
                    onplay="{{ playEvent() }}"
                    onpause="{{ pauseEvent() }}"
                    onended="{{ ended() }}"
                  >
                    <media-provider></media-provider>

                    <media-gesture event="pointerup" action="toggle:paused"></media-gesture>
                    <media-gesture event="dblpointerup" action="toggle:fullscreen"></media-gesture>
                    <media-gesture event="pointerup" action="toggle:controls"></media-gesture>
                    <media-gesture event="dblpointerup" action="seek:-10"></media-gesture>
                    <media-gesture event="dblpointerup" action="seek:10"></media-gesture>

                    <media-controls>
                      <div class="media-controls-spacer"></div>
                      <media-controls-group>
                        <!-- Time Slider -->
                        <media-time-slider class="media-slider">
                          <media-slider-chapters>
                            <template>
                              <div class="media-slider-chapter">
                                <div class="media-slider-track"></div>
                                <div class="media-slider-track-fill media-slider-track"></div>
                                <div class="media-slider-progress media-slider-track"></div>
                              </div>
                            </template>
                          </media-slider-chapters>
                          <div class="media-slider-thumb"></div>
                        </media-time-slider>
                      </media-controls-group>

                      <media-controls-group>
                        <!-- Play Button -->
                        <media-tooltip>
                          <media-tooltip-trigger>
                            <media-play-button class="media-button">
                              <media-icon class="media-play-icon" type="play"></media-icon>
                              <media-icon class="media-pause-icon" type="pause"></media-icon>
                            </media-play-button>
                          </media-tooltip-trigger>
                          <media-tooltip-content class="media-tooltip" placement="top">
                            <span class="media-play-tooltip-text">Play</span>
                            <span class="media-pause-tooltip-text">Pause</span>
                          </media-tooltip-content>
                        </media-tooltip>

                        <!-- Mute Button -->
                        <media-tooltip>
                          <media-tooltip-trigger>
                            <media-mute-button class="media-button">
                              <media-icon class="media-mute-icon" type="mute"></media-icon>
                              <media-icon class="media-volume-low-icon" type="volume-low"></media-icon>
                              <media-icon class="media-volume-high-icon" type="volume-high"></media-icon>
                            </media-mute-button>
                          </media-tooltip-trigger>
                          <media-tooltip-content class="media-tooltip" placement="top">
                            <span class="media-mute-tooltip-text">Unmute</span>
                            <span class="media-unmute-tooltip-text">Mute</span>
                          </media-tooltip-content>
                        </media-tooltip>

                        <!-- Volume Slider -->
                        <media-volume-slider class="media-slider">
                          <div class="media-slider-track"></div>
                          <div class="media-slider-track-fill media-slider-track"></div>
                          <div class="media-slider-thumb"></div>
                          <media-slider-preview no-clamp>
                            <media-slider-value></media-slider-value>
                          </media-slider-preview>
                        </media-volume-slider>

                        <!-- Time Group -->
                        <div class="media-time-group">
                          <media-time type="current"></media-time>
                          <div class="media-time-divider">/</div>
                          <media-time type="duration"></media-time>
                        </div>

                        <media-chapter-title></media-chapter-title>

                        <div class="media-controls-spacer"></div>

                        <!-- Fullscreen Button -->
                        <media-tooltip>
                          <media-tooltip-trigger>
                            <media-fullscreen-button class="media-button">
                              <media-icon class="media-fs-enter-icon" type="fullscreen"></media-icon>
                              <media-icon class="media-fs-exit-icon" type="fullscreen-exit"></media-icon>
                            </media-fullscreen-button>
                          </media-tooltip-trigger>
                          <media-tooltip-content class="media-tooltip" placement="top end">
                            <span class="media-fs-enter-tooltip-text">Enter Fullscreen</span>
                            <span class="media-fs-exit-tooltip-text">Exit Fullscreen</span>
                          </media-tooltip-content>
                        </media-tooltip>
                      </media-controls-group>
                    </media-controls>
                  </media-player>
                </div>
              </div>
            </div>
            <div class="btn_box">
              <button *ngIf="continue == false" mat-flat-button (click)="continue = true">연속재생</button>
              <button *ngIf="continue == true" mat-flat-button (click)="continue = false">연속재생 해제</button>
            </div>
          </div>
        </div>

        <!--vod info-->
        <div class="col-lg-4">
          <div class="view view_txt" *ngIf="loading == false">
            <div class="header_txt">
              <h3>{{ this.selectedVod.title }}</h3>
            </div>
            <div class="inner-info">
              <div>
                <img src="../../../../assets/images/timer.svg" />
                <span *ngIf="selectedVod.vod_min == 0"> -- 분</span>
                <span *ngIf="selectedVod.vod_min > 0"> {{ this.selectedVod.vod_min }} 분</span>
              </div>
              <div>
                <img src="../../../../assets/images/star.svg" />
                <img *ngIf="selectedVod.level == 2 || selectedVod.level == 3" src="../../../../assets/images/star.svg" />
                <img *ngIf="selectedVod.level == 3" src="../../../../assets/images/star.svg" />
              </div>
              <div [ngClass]="selectedVod.favorite ? 'favorite-btn' : ''" (click)="toggleFavorite(selectedVod.id, selectedVod.favorite)" style="background: rgba(255, 255, 255, 0.2); cursor: pointer">
                <img *ngIf="selectedVod.favorite == false" src="../../../../assets/images/empty-favorite.svg" />
                <img *ngIf="selectedVod.favorite == true" src="../../../../assets/images/favorite.svg" />
                즐겨찾기
              </div>
            </div>
            <br /><br /><br />
            <div class="playlist_txt">
              <p *ngIf="selectedVod.gangsa !== ''" class="name_txt">강사 {{ this.selectedVod.gangsa }}쌤</p>
              <p>{{ this.selectedVod.content }}</p>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div *ngIf="loading == true" style="width: 100%">
        <mat-spinner diameter="50" style="margin: 30% auto" class="custom-spinner"></mat-spinner>
      </div>
      <div *ngIf="loading == false" class="thumbnail_wrap">
        <div class="col-xs-4 col-sm-4 col-md-4 thumbnail_box" *ngFor="let vod of vodListCategory?.vod_list | slice : (page - 1) * pageSize : (page - 1) * pageSize + pageSize">
          <div (click)="changeSelectedContent(vod)">
            <div class="img_wrap">
              <video
                id="themVod"
                onmouseover="if (this.readyState >= 2) {this.play();}"
                onmouseout="if (this.readyState >= 2 && this.paused != true) {this.pause();this.currentTime = 0;}"
                loop
                muted="{{ true }}"
                poster="{{ vod.thumbnail }}"
                width="100%"
                src="{{ vod.preview }}"
              ></video>
              <img src="{{ vod.thumbnail }}" alt="thumbnail" title="{{ vod.title }}" />
            </div>
            <div class="thumbnail_txt">{{ vod.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <ngb-pagination
      [collectionSize]="vodListCategory?.vod_list.length"
      [(page)]="page"
      [pageSize]="pageSize"
      [maxSize]="5"
      [rotate]="true"
      [ellipses]="false"
      [boundaryLinks]="true"
      class="d-flex justify-content-center"
      style="font-size: 15px"
    >
    </ngb-pagination>
  </div>
</div>
<div class="body_bg"></div>
